// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Toolbar,
//   Container,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   TextField,
//   InputAdornment,
//   IconButton,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";

// import cleanJobDescription from "./cleanJobDescription";

// import VisibilityIcon from "@mui/icons-material/Visibility";
// import ApplyForm from "./ApplyForm";
// import { useNavigate } from "react-router-dom";
// // import cleanJobDescription from "./cleanJobDescription";
// import { API_URL } from "./config";

// export default function JobBoard() {
//   const navigate = useNavigate();
//   const [jobOrders, setJobOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [search, setSearch] = useState("");
//   const [selectedJobOrder, setSelectedJobOrder] = useState(null);
//   const [detailsOpen, setDetailsOpen] = useState(false);
//   const [applyOpen, setApplyOpen] = useState(false);

//   useEffect(() => {
//     fetchJobOrders();
//   }, []);

//   const fetchJobOrders = async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const res = await fetch(`${API_URL}/joborder/uprotected`);
//       if (!res.ok) throw new Error("Failed to fetch job orders");
//       const data = await res.json();
//       setJobOrders(data);
//     } catch (e) {
//       setError(e.message);
//       setJobOrders([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleViewDetails = (jobOrder) => {
//     setSelectedJobOrder(jobOrder);
//     setDetailsOpen(true);
//   };

//   const handleApply = (jobOrder) => {
//     navigate(`/apply/${jobOrder.id}`);
//   };

//   const filteredJobOrders = jobOrders.filter((job) => {
//     if (!search.trim()) return true;
    
//     const searchTerm = search.toLowerCase().trim();
//     const searchInLocations = Array.isArray(job.locations) 
//       ? job.locations
//           .map(loc => (typeof loc === 'string' ? loc : loc.name || '').toLowerCase())
//           .join(' ')
//       : '';
    
//     const searchInJobTypes = Array.isArray(job.job_types)
//       ? job.job_types
//           .map(type => (typeof type === 'string' ? type : type.name || '').toLowerCase())
//           .join(' ')
//       : '';

//     return (
//       (job.job_title?.toLowerCase() || '').includes(searchTerm) ||
//       (job.department?.toLowerCase() || '').includes(searchTerm) ||
//       searchInLocations.includes(searchTerm) ||
//       searchInJobTypes.includes(searchTerm) ||
//       (job.description?.toLowerCase() || '').includes(searchTerm)
//     );
//   });

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         minHeight: "100vh",
//         background: "#f9f9f9",
//       }}
//     >
//       <Toolbar />
//       <Container maxWidth="lg" sx={{ py: 7, maxWidth: 1400 }}>
//         <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
//           Available Job Orders
//         </Typography>
//         <Paper sx={{ p: 2, mb: 2 }}>
//           <TextField
//             label="Search by title, department, or location"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             fullWidth
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton>
//                     <SearchIcon />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Paper>
//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 7 }}>
//             <CircularProgress />
//           </Box>
//         ) : error ? (
//           <Typography color="error">{error}</Typography>
//         ) : (
//           <TableContainer
//             component={Paper}
//             sx={{ minWidth: 1100, maxWidth: "100%" }}
//           >
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Title</TableCell>
//                   <TableCell>Department</TableCell>
//                   <TableCell>Location</TableCell>
//                   <TableCell>Type</TableCell>
//                   <TableCell>Status</TableCell>
//                   <TableCell sx={{ width: 200 }}>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {filteredJobOrders.length === 0 ? (
//                   <TableRow>
//                     <TableCell colSpan={7}>
//                       <Typography>No job orders found.</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   filteredJobOrders.map((job) => {
//                     // Clean up job title by removing 'Job Title:' prefix if it exists
//                     const cleanJobTitle = (job.job_title || '').replace(/^Job Title:\s*/i, '').trim();
                    
//                     return (
//                       <TableRow key={job.id}>
//                         <TableCell>{cleanJobTitle}</TableCell>
//                         <TableCell>{job.department}</TableCell>
//                         <TableCell>
//                           {Array.isArray(job.locations) &&
//                           job.locations.length > 0
//                             ? job.locations
//                                 .map((loc) =>
//                                   typeof loc === "string" ? loc : loc.name
//                                 )
//                                 .filter(Boolean)
//                                 .join(", ")
//                             : "-"}
//                         </TableCell>
//                         <TableCell>
//                           {Array.isArray(job.job_types) &&
//                           job.job_types.length > 0
//                             ? job.job_types
//                                 .map((loc) =>
//                                   typeof loc === "string" ? loc : loc.name
//                                 )
//                                 .filter(Boolean)
//                                 .join(", ")
//                             : "-"}
//                         </TableCell>
//                         <TableCell>{job.status}</TableCell>
//                         <TableCell>
//                           <IconButton
//                             onClick={() => handleViewDetails(job)}
//                             title="View Details"
//                           >
//                             <VisibilityIcon />
//                           </IconButton>
//                           <Button
//                             variant="contained"
//                             sx={{ ml: 1 }}
//                             onClick={() => handleApply(job)}
//                           >
//                             Apply
//                           </Button>
//                         </TableCell>
//                       </TableRow>
//                     );
//                   })
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </Container>
//       {/* Details Dialog */}
//       <Dialog
//         open={detailsOpen}
//         onClose={() => setDetailsOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           Job Order Details
//           {selectedJobOrder && (
//             <Button
//               variant="contained"
//               color="primary"
//               size="medium"
//               sx={{ ml: 2 }}
//               onClick={() => {
//                 setDetailsOpen(false);
//                 window.location.href = `/apply/${selectedJobOrder.id}`;
//               }}
//             >
//               Apply
//             </Button>
//           )}
//         </DialogTitle>
//         <DialogContent>
//           {selectedJobOrder ? (
//             <Box>
//               <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
//                 {selectedJobOrder.job_title}
//               </Typography>
//               <Typography
//                 variant="subtitle1"
//                 color="text.secondary"
//                 sx={{ mb: 2 }}
//               >
//                 {selectedJobOrder.department} |{" "}
//                 {Array.isArray(selectedJobOrder.locations) &&
//                 selectedJobOrder.locations.length > 0
//                   ? selectedJobOrder.locations
//                       .map((loc) => (typeof loc === "string" ? loc : loc.name))
//                       .filter(Boolean)
//                       .join("; ")
//                   : "-"}
//               </Typography>
//               <Box sx={{ my: 2 }}>
//                 <Box sx={{ mb: 2, whiteSpace: "pre-line" }}>
//                   <div
//                     dangerouslySetInnerHTML={{
//                       __html: cleanJobDescription(
//                         selectedJobOrder.job_description || ""
//                       ),
//                     }}
//                   />
//                 </Box>
//               </Box>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                 <b>Type:</b>{" "}
//                 {Array.isArray(selectedJobOrder.job_types) &&
//                 selectedJobOrder.job_types.length > 0
//                   ? selectedJobOrder.job_types
//                       .map((loc) => (typeof loc === "string" ? loc : loc.name))
//                       .filter(Boolean)
//                       .join("; ")
//                   : "-"}{" "}
//                 &nbsp; | &nbsp; <b>Apply Before:</b>{" "}
//                 {selectedJobOrder.end_date
//                   ? window.dayjs
//                     ? window
//                         .dayjs(selectedJobOrder.end_date)
//                         .format(" D MMMM, YYYY, h:mm A")
//                     : new Date(selectedJobOrder.end_date).toLocaleString()
//                   : "-"}
//               </Typography>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 size="large"
//                 fullWidth
//                 sx={{ mt: 2, mb: 1 }}
//                 onClick={() => {
//                   setDetailsOpen(false);
//                   window.location.href = `/apply/${selectedJobOrder.id}`;
//                 }}
//               >
//                 Apply Now
//               </Button>
//             </Box>
//           ) : null}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDetailsOpen(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>
//       {/* Apply Dialog */}
//       <Dialog
//         open={applyOpen}
//         onClose={() => setApplyOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Apply for {selectedJobOrder?.title}</DialogTitle>
//         <DialogContent>
//           {selectedJobOrder && (
//             <ApplyForm
//               jobOrder={selectedJobOrder}
//               onSuccess={() => setApplyOpen(false)}
//             />
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setApplyOpen(false)}>Cancel</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  TextField,
  InputAdornment,
  Chip,
  Divider,
  Alert,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import cleanJobDescription from "./cleanJobDescription";
import { useNavigate } from "react-router-dom";
import { API_URL } from "./config";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

function getLocations(job) {
  return Array.isArray(job.locations) && job.locations.length > 0
    ? job.locations
        .map((loc) => (typeof loc === "string" ? loc : loc?.name))
        .filter(Boolean)
        .join(", ")
    : "Remote / Flexible";
}

function getJobTypes(job) {
  return Array.isArray(job.job_types) && job.job_types.length > 0
    ? job.job_types
        .map((type) => (typeof type === "string" ? type : type?.name))
        .filter(Boolean)
    : [];
}

function formatDeadline(value) {
  if (!value) return "-";
  return window.dayjs
    ? window.dayjs(value).format("D MMMM, YYYY")
    : new Date(value).toLocaleDateString();
}

function isNewJob(job) {
  const created = new Date(job.created_at || job.created);
  return Date.now() - created.getTime() < 7 * 24 * 60 * 60 * 1000;
}

export default function JobBoard() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const navigate = useNavigate();

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const cardBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";
  const borderStrong = dark ? "rgba(99, 179, 237, 0.22)" : "#d4d4e4";

  const [jobOrders, setJobOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [selectedJobOrder, setSelectedJobOrder] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);

  useEffect(() => {
    fetchJobOrders();
  }, []);

  const fetchJobOrders = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${API_URL}/joborder/uprotected`);
      if (!res.ok) throw new Error("Failed to fetch job orders");

      const data = await res.json();
      setJobOrders(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.message || "Failed to fetch job orders.");
      setJobOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredJobOrders = useMemo(() => {
    return jobOrders.filter((job) => {
      if (!search.trim()) return true;

      const searchTerm = search.toLowerCase().trim();
      const searchInLocations = Array.isArray(job.locations)
        ? job.locations
            .map((loc) =>
              (typeof loc === "string" ? loc : loc?.name || "").toLowerCase()
            )
            .join(" ")
        : "";

      const searchInJobTypes = Array.isArray(job.job_types)
        ? job.job_types
            .map((type) =>
              (typeof type === "string" ? type : type?.name || "").toLowerCase()
            )
            .join(" ")
        : "";

      return (
        (job.job_title?.toLowerCase() || "").includes(searchTerm) ||
        (job.department?.toLowerCase() || "").includes(searchTerm) ||
        searchInLocations.includes(searchTerm) ||
        searchInJobTypes.includes(searchTerm) ||
        (job.job_description?.toLowerCase() || "").includes(searchTerm)
      );
    });
  }, [jobOrders, search]);

  const handleViewDetails = (jobOrder) => {
    setSelectedJobOrder(jobOrder);
    setDetailsOpen(true);
  };

  const handleApply = (jobOrder) => {
    navigate(`/apply/${jobOrder.id}`);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: pageBg,
        pt: { xs: 11, md: 13 },
        pb: 10,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background: dark
            ? `radial-gradient(circle at 15% 12%, ${alpha(accent, 0.12)} 0%, transparent 26%),
               radial-gradient(circle at 85% 18%, rgba(56,189,248,0.10) 0%, transparent 24%)`
            : `radial-gradient(circle at 15% 12%, ${alpha(accent, 0.08)} 0%, transparent 24%),
               radial-gradient(circle at 85% 18%, rgba(79,70,229,0.06) 0%, transparent 22%)`,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            mb: 5,
            overflow: "hidden",
            borderRadius: "28px",
            border: `1px solid ${border}`,
            background: dark
              ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
              : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
            boxShadow: dark
              ? "0 32px 80px rgba(0,0,0,0.45)"
              : "0 32px 80px rgba(15,15,26,0.08)",
          }}
        >
          <Grid container>
            <Grid item xs={12} md={7.5}>
              <Box sx={{ p: { xs: 3, sm: 4, md: 5 } }}>
                <SectionEyebrow color={accent}>AjiraHQ · Jobs</SectionEyebrow>

                <Typography
                  sx={{
                    mt: 2,
                    fontSize: { xs: "2.2rem", md: "3.5rem" },
                    fontWeight: 800,
                    color: text,
                    lineHeight: 1.05,
                    letterSpacing: "-0.03em",
                    maxWidth: 760,
                  }}
                >
                  Explore all open roles in one place.
                </Typography>

                <Typography
                  sx={{
                    mt: 2,
                    color: mid,
                    fontSize: { xs: "1rem", md: "1.08rem" },
                    lineHeight: 1.8,
                    maxWidth: 620,
                  }}
                >
                  Browse opportunities, review role details, and move straight
                  into a structured application flow.
                </Typography>

                <Box
                  sx={{
                    mt: 4,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 4,
                    borderTop: `1px solid ${border}`,
                    pt: 3.5,
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "2rem", md: "2.35rem" },
                        fontWeight: 800,
                        color: text,
                        lineHeight: 1,
                      }}
                    >
                      {jobOrders.length}
                    </Typography>
                    <Typography
                      sx={{
                        mt: 0.5,
                        fontSize: "11px",
                        letterSpacing: "0.16em",
                        textTransform: "uppercase",
                        color: muted,
                        fontFamily:
                          '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                      }}
                    >
                      Open positions
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "2rem", md: "2.35rem" },
                        fontWeight: 800,
                        color: accent,
                        lineHeight: 1,
                      }}
                    >
                      {jobOrders.filter(isNewJob).length}
                    </Typography>
                    <Typography
                      sx={{
                        mt: 0.5,
                        fontSize: "11px",
                        letterSpacing: "0.16em",
                        textTransform: "uppercase",
                        color: muted,
                        fontFamily:
                          '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                      }}
                    >
                      New this week
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={4.5}>
              <Box
                sx={{
                  height: "100%",
                  p: { xs: 3, sm: 4, md: 5 },
                  borderTop: { xs: `1px solid ${border}`, md: "none" },
                  borderLeft: { xs: "none", md: `1px solid ${border}` },
                  background: dark
                    ? "rgba(8,12,24,0.45)"
                    : "rgba(255,255,255,0.55)",
                }}
              >
                <Box
                  sx={{
                    p: 3,
                    borderRadius: "22px",
                    border: `1px solid ${border}`,
                    background: dark
                      ? "rgba(13,18,32,0.9)"
                      : "rgba(255,255,255,0.88)",
                  }}
                >
                  <SectionEyebrow color={accent}>Search roles</SectionEyebrow>

                  <Typography
                    sx={{
                      mt: 2,
                      color: text,
                      fontWeight: 800,
                      fontSize: "1.5rem",
                      lineHeight: 1.15,
                      letterSpacing: "-0.02em",
                    }}
                  >
                    Find the right role faster
                  </Typography>

                  <Typography
                    sx={{
                      mt: 1,
                      color: mid,
                      fontSize: "14px",
                      lineHeight: 1.75,
                      mb: 2.5,
                    }}
                  >
                    Search by title, department, location, or type.
                  </Typography>

                  <TextField
                    placeholder="Search by role, location, or keyword..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: muted, fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        bgcolor: dark ? "rgba(8,12,24,0.7)" : "#ffffff",
                        borderRadius: "14px",
                        fontSize: "0.95rem",
                        transition: "all 0.2s ease",
                        "& fieldset": {
                          borderColor: border,
                        },
                        "&:hover fieldset": {
                          borderColor: borderStrong,
                        },
                        "&.Mui-focused": {
                          boxShadow: `0 0 0 4px ${alpha(accent, 0.12)}`,
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: accent,
                        },
                      },
                      "& .MuiInputBase-input": {
                        py: 1.55,
                        color: text,
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 7 }}>
            <CircularProgress sx={{ color: accent }} />
          </Box>
        ) : error ? (
          <Alert
            severity="error"
            sx={{
              borderRadius: "18px",
              mb: 3,
            }}
          >
            {error}
          </Alert>
        ) : (
          <Grid container spacing={3}>
            {filteredJobOrders.length === 0 ? (
              <Grid item xs={12}>
                <Box
                  sx={{
                    textAlign: "center",
                    py: 10,
                    borderRadius: "24px",
                    border: `1px solid ${border}`,
                    background: cardBg,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "1.125rem",
                      color: text,
                      fontWeight: 700,
                    }}
                  >
                    No matching roles right now.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.9375rem",
                      color: mid,
                      mt: 1,
                    }}
                  >
                    Try another keyword or check back again soon.
                  </Typography>
                </Box>
              </Grid>
            ) : (
              filteredJobOrders.map((job) => {
                const cleanJobTitle = (job.job_title || "")
                  .replace(/^Job Title:\s*/i, "")
                  .trim();
                const jobTypes = getJobTypes(job);
                const isNew = isNewJob(job);

                return (
                  <Grid item xs={12} sm={6} lg={4} key={job.id}>
                    <Card
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        border: `1px solid ${border}`,
                        borderRadius: "24px",
                        background: cardBg,
                        boxShadow: dark
                          ? "0 20px 50px rgba(0,0,0,0.28)"
                          : "0 20px 50px rgba(15,15,26,0.05)",
                        transition:
                          "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
                        cursor: "pointer",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          borderColor: accent,
                          boxShadow: dark
                            ? `0 28px 60px rgba(0,0,0,0.35), 0 0 0 1px ${alpha(
                                accent,
                                0.18
                              )}`
                            : `0 28px 60px rgba(15,15,26,0.08), 0 0 0 1px ${alpha(
                                accent,
                                0.14
                              )}`,
                        },
                      }}
                      onClick={() => handleApply(job)}
                    >
                      <CardContent
                        sx={{
                          p: 3,
                          flexGrow: 1,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            gap: 1.5,
                            mb: 2.25,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "1.2rem",
                              fontWeight: 800,
                              color: text,
                              lineHeight: 1.25,
                              letterSpacing: "-0.02em",
                            }}
                          >
                            {cleanJobTitle}
                          </Typography>

                          {isNew && (
                            <Chip
                              label="New"
                              size="small"
                              sx={{
                                borderRadius: 999,
                                fontWeight: 700,
                                fontSize: "0.72rem",
                                background: alpha(accent, dark ? 0.14 : 0.08),
                                color: accent,
                                border: `1px solid ${alpha(accent, 0.24)}`,
                              }}
                            />
                          )}
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.35,
                            mb: 2.5,
                            flexGrow: 1,
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <BusinessCenterOutlinedIcon
                              sx={{ fontSize: 18, color: muted }}
                            />
                            <Typography
                              sx={{
                                fontSize: "0.92rem",
                                color: mid,
                                lineHeight: 1.7,
                              }}
                            >
                              {job.department || "General hiring"}
                            </Typography>
                          </Box>

                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <LocationOnOutlinedIcon
                              sx={{ fontSize: 18, color: muted }}
                            />
                            <Typography
                              sx={{
                                fontSize: "0.92rem",
                                color: mid,
                                lineHeight: 1.7,
                              }}
                            >
                              {getLocations(job)}
                            </Typography>
                          </Box>

                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                            {jobTypes.length > 0 ? (
                              jobTypes.map((type, idx) => (
                                <Chip
                                  key={`${job.id}-${type}-${idx}`}
                                  label={type}
                                  size="small"
                                  sx={{
                                    borderRadius: 999,
                                    background: dark
                                      ? "rgba(255,255,255,0.04)"
                                      : "rgba(15,15,26,0.03)",
                                    color: mid,
                                    border: `1px solid ${border}`,
                                    fontWeight: 600,
                                  }}
                                />
                              ))
                            ) : (
                              <Chip
                                label="Unspecified type"
                                size="small"
                                sx={{
                                  borderRadius: 999,
                                  background: dark
                                    ? "rgba(255,255,255,0.04)"
                                    : "rgba(15,15,26,0.03)",
                                  color: mid,
                                  border: `1px solid ${border}`,
                                  fontWeight: 600,
                                }}
                              />
                            )}
                          </Box>

                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography
                              sx={{
                                minWidth: 86,
                                fontSize: "11px",
                                fontWeight: 500,
                                letterSpacing: "0.16em",
                                textTransform: "uppercase",
                                color: muted,
                                fontFamily:
                                  '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                              }}
                            >
                              Apply by
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.9rem",
                                color: text,
                                fontWeight: 600,
                              }}
                            >
                              {formatDeadline(job.end_date)}
                            </Typography>
                          </Box>
                        </Box>

                        <Divider sx={{ mb: 2.5, borderColor: border }} />

                        <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap" }}>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewDetails(job);
                            }}
                            sx={{
                              textTransform: "none",
                              fontWeight: 600,
                              fontSize: "0.875rem",
                              borderRadius: "12px",
                              px: 2.2,
                              py: 0.9,
                              borderColor: borderStrong,
                              color: mid,
                              "&:hover": {
                                borderColor: accent,
                                color: accent,
                                background: "transparent",
                              },
                            }}
                          >
                            View details
                          </Button>

                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleApply(job);
                            }}
                            sx={{
                              textTransform: "none",
                              fontWeight: 700,
                              fontSize: "0.875rem",
                              borderRadius: "12px",
                              px: 2.4,
                              py: 0.9,
                              background: accent,
                              color: "#fff",
                              boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                              "&:hover": {
                                background: accent,
                                filter: "brightness(1.08)",
                              },
                            }}
                          >
                            Apply now
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })
            )}
          </Grid>
        )}

        <Dialog
          open={detailsOpen}
          onClose={() => setDetailsOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "24px",
              border: `1px solid ${border}`,
              background: cardBg,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.28)"
                : "0 20px 50px rgba(15,15,26,0.05)",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 800,
              fontSize: "1.6rem",
              color: text,
              pt: 4,
              px: 4,
              pb: 2,
              letterSpacing: "-0.02em",
            }}
          >
            {selectedJobOrder?.job_title}
          </DialogTitle>

          <DialogContent sx={{ px: 4, pb: 3 }}>
            {selectedJobOrder ? (
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.25,
                    mb: 3,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <BusinessCenterOutlinedIcon sx={{ fontSize: 18, color: muted }} />
                    <Typography sx={{ fontSize: "0.92rem", color: mid }}>
                      {selectedJobOrder.department || "General hiring"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <LocationOnOutlinedIcon sx={{ fontSize: 18, color: muted }} />
                    <Typography sx={{ fontSize: "0.92rem", color: mid }}>
                      {getLocations(selectedJobOrder)}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 3, borderColor: border }} />

                <Box
                  sx={{
                    mb: 3,
                    "& p": {
                      color: mid,
                      lineHeight: 1.85,
                      fontSize: "15px",
                    },
                    "& h1, & h2, & h3, & h4": {
                      color: text,
                      fontWeight: 800,
                      letterSpacing: "-0.02em",
                    },
                    "& ul, & ol": {
                      color: mid,
                      pl: 2.5,
                    },
                    "& li": {
                      mb: 1,
                      lineHeight: 1.75,
                    },
                    "& strong": {
                      color: text,
                    },
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: cleanJobDescription(
                        selectedJobOrder.job_description || ""
                      ),
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.88rem",
                      color: text,
                    }}
                  >
                    Type:
                  </Typography>

                  {getJobTypes(selectedJobOrder).length > 0 ? (
                    getJobTypes(selectedJobOrder).map((type, idx) => (
                      <Chip
                        key={`${selectedJobOrder.id}-${type}-${idx}`}
                        label={type}
                        size="small"
                        sx={{
                          borderRadius: 999,
                          background: dark
                            ? "rgba(255,255,255,0.04)"
                            : "rgba(15,15,26,0.03)",
                          color: mid,
                          border: `1px solid ${border}`,
                          fontWeight: 600,
                        }}
                      />
                    ))
                  ) : (
                    <Chip
                      label="-"
                      size="small"
                      sx={{
                        borderRadius: 999,
                        background: dark
                          ? "rgba(255,255,255,0.04)"
                          : "rgba(15,15,26,0.03)",
                        color: mid,
                        border: `1px solid ${border}`,
                      }}
                    />
                  )}
                </Box>

                <Typography sx={{ mb: 1.25, fontSize: "0.92rem", color: mid }}>
                  <strong style={{ color: text }}>Status:</strong>{" "}
                  {selectedJobOrder.status || "-"}
                </Typography>

                <Typography sx={{ fontSize: "0.92rem", color: mid }}>
                  <strong style={{ color: text }}>Apply before:</strong>{" "}
                  {formatDeadline(selectedJobOrder.end_date)}
                </Typography>
              </Box>
            ) : null}
          </DialogContent>

          <DialogActions sx={{ px: 4, pb: 4, pt: 2 }}>
            <Button
              onClick={() => setDetailsOpen(false)}
              sx={{
                textTransform: "none",
                color: mid,
                fontWeight: 600,
                "&:hover": {
                  background: dark ? "rgba(255,255,255,0.04)" : "#f9fafb",
                },
              }}
            >
              Close
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                setDetailsOpen(false);
                navigate(`/apply/${selectedJobOrder?.id}`);
              }}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                borderRadius: "12px",
                background: accent,
                px: 3,
                boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                "&:hover": {
                  background: accent,
                  filter: "brightness(1.08)",
                },
              }}
            >
              Apply now
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
}